/** @format */

export interface ScoreCard {
  number: string;
  estimatedPointsEarned?: number;
}
